// Services
import AuthenticationService from '@/services/AuthenticationService';
import { EventBus } from '@/EventBus.js';


export default {
  name: 'navigation',

  data: function () {
    return {
      userGroup: null,
      homeRoute: null,
      user: null,

      navItems: {
        'hsg-admins': [
          { route: '/retailers', name: 'Retailers' },
          { route: '/retailers-multi', name: 'Multi-Site Retailers' },
          { route: '/reviews', name: 'Reviews' },
          { route: '/washrooms', name: 'Washrooms' },
          { route: '/service-providers', name: 'Service Providers' },
          { route: '/account', name: 'Manage Account' },
          { route: '/admin', name: 'Admin' }
        ],
        'service-providers': [
          { route: '/service-relationships', name: 'Connections' },
          { route: '/retailers', name: 'Retailers' },
          { route: '/retailers-multi', name: 'Multi-Site Retailers' },
          { route: '/reviews', name: 'Reviews' },
          { route: '/washrooms', name: 'Washrooms' },
          { route: '/account', name: 'Manage Account' }
        ],
        'multi-site-retailers': [
          { route: '/retailers', name: 'Retailers' },
          { route: '/reviews', name: 'Reviews' },
          { route: '/washrooms', name: 'Washrooms' },
          { route: '/service-providers', name: 'Service Providers' },
          { route: '/account', name: 'Manage Account' }
        ],
        'retailers': [
          { route: '/retailers/' + localStorage.getItem('parentId'), name: 'Site Info' },
          { route: '/service-relationships', name: 'Connections' },
          { route: '/reviews', name: 'Reviews' },
          { route: '/washrooms', name: 'Washrooms' },
          { route: '/account', name: 'Manage Account' }
        ]
      }
    }
  },

  created: function() {
    this.userGroup = localStorage.getItem('userGroup');
    this.homeRoute = localStorage.getItem('homeRoute');
    this.user = JSON.parse(localStorage.getItem('userObject'));
  },

  beforeDestroy: function() {

  },

  methods: {
    doLogout: function () {
      AuthenticationService.logout(this.$router);
    }
  },

  computed:{
    userRole: function() {
      switch(this.userGroup) {
        case 'hsg-admins':
          return 'HSG Admin';

        case 'service-providers':
          return 'Service Provider';

        case 'multi-site-retailers':
          return 'Multi-Site Retailer';

        case 'retailers':
          return 'Retailer';
      }

      return 'Unknown Role';
    },

    userInitials: function() {
      var names = this.user.fullName.split(' ');

      var firstLetters = '';

      // If name consists of a single word
      if(names.length == 1) {
        firstLetters = names[0].substring(0,2);
      }
      // If name consists of more than one word
      else {
        while(names.length > 0 && firstLetters.length <= 2)
        {
          firstLetters += names.shift()[0];
        }
      }

      return firstLetters
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/Navigation/Navigation.js